import { render } from "./SupplyRiepilogoSection.vue?vue&type=template&id=75f7bbcf&scoped=true"
import script from "./SupplyRiepilogoSection.vue?vue&type=script&lang=js"
export * from "./SupplyRiepilogoSection.vue?vue&type=script&lang=js"

import "./SupplyRiepilogoSection.vue?vue&type=style&index=0&id=75f7bbcf&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75f7bbcf"]])

export default __exports__